import { render } from "./dermatology_history.vue?vue&type=template&id=51d437b8&scoped=true"
import script from "./dermatology_history.vue?vue&type=script&lang=js"
export * from "./dermatology_history.vue?vue&type=script&lang=js"

import "./dermatology_history.vue?vue&type=style&index=0&id=51d437b8&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51d437b8"]])

export default __exports__